// Text
export const COMMON_ERROR = 'An unexpected error has occurred. Please try again later'
